module.exports = __webpack_public_path__ + "media/components/src/assets/images/staffs/staff_2-a2950faf42b4c0fb37367ae72f6765a2.jpg";